import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
import { useFormikContext } from "formik";
import moment from "moment";
import React from "react";
import CurrencyFormat from "react-currency-format";
import { NumericFormat } from "react-number-format";
export default function InvoicePaymentList(param) {
    var arrayHelpers = param.arrayHelpers;
    var _values_factNewInvPayment;
    var _useInvoiceInitContext = useInvoiceInitContext(), modalInvoiceModalState = _useInvoiceInitContext.modalInvoiceModalState, options = _useInvoiceInitContext.options;
    var setModalInvPayment = modalInvoiceModalState.setModalInvPayment;
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, errors = _useFormikContext.errors, setFieldValue = _useFormikContext.setFieldValue, handleChange = _useFormikContext.handleChange;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: (_values_factNewInvPayment = values.factNewInvPayment) === null || _values_factNewInvPayment === void 0 ? void 0 : _values_factNewInvPayment.map(function(item, index) {
            var _item_factNewInvPaymentRow, _item_factNewInvAdjustmentOrFee;
            return /*#__PURE__*/ _jsxs("div", {
                className: "py-[24px]",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex gap-[20px]",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex gap-[10px]",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "rounded-full w-[24px] h-[24px] bg-[#FF731D] flex justify-center items-center",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                className: "absolute aspect-square w-[16px]",
                                                src: "/images/icon-check-white.png",
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "font-bold fs-18",
                                            children: [
                                                "ชำระเงินครั้งที่ ",
                                                index + 1
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex gap-[15px]",
                                    children: [
                                        /*#__PURE__*/ _jsx("button", {
                                            type: "button",
                                            onClick: function() {
                                                setModalInvPayment(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: true,
                                                        paymentIndex: index,
                                                        modeInv: "edit"
                                                    });
                                                });
                                            },
                                            className: "rounded-full aspect-square w-[32px] bg-[#E3E8F0] flex items-center justify-center",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                className: "aspect-square w-[13px]",
                                                src: "/images/icon-edit-pen-grey.png",
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("button", {
                                            type: "button",
                                            onClick: function() {
                                                return arrayHelpers.remove(index);
                                            },
                                            className: "rounded-full aspect-square w-[32px] bg-[#F95057] flex items-center justify-center",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                className: "aspect-square w-[23px]",
                                                src: "/images/icon-trash.png",
                                                alt: ""
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mt-[20px] w-[600px] fs-16 tc-7 flex flex-col gap-[10px]",
                        children: [
                            item === null || item === void 0 ? void 0 : (_item_factNewInvPaymentRow = item.factNewInvPaymentRow) === null || _item_factNewInvPaymentRow === void 0 ? void 0 : _item_factNewInvPaymentRow.map(function(v, i) {
                                var _options_branchPaymentChannel_find;
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: ((_options_branchPaymentChannel_find = options.branchPaymentChannel.find(function(d) {
                                                return d.value == v.dim_branch_payment_channel_id;
                                            })) === null || _options_branchPaymentChannel_find === void 0 ? void 0 : _options_branchPaymentChannel_find.label) || "-"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex gap-[5px]",
                                            children: [
                                                /*#__PURE__*/ _jsx(NumericFormat, {
                                                    value: v.price,
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                }),
                                                "บาท"
                                            ]
                                        })
                                    ]
                                }, "pay-row-item-".concat(i));
                            }),
                            item === null || item === void 0 ? void 0 : (_item_factNewInvAdjustmentOrFee = item.factNewInvAdjustmentOrFee) === null || _item_factNewInvAdjustmentOrFee === void 0 ? void 0 : _item_factNewInvAdjustmentOrFee.map(function(v, i) {
                                var _options_adjustOrFee_find;
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: ((_options_adjustOrFee_find = options.adjustOrFee.find(function(d) {
                                                return d.value == v.dim_mst_adjust_or_fee_id;
                                            })) === null || _options_adjustOrFee_find === void 0 ? void 0 : _options_adjustOrFee_find.label) || "-"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex gap-[5px]",
                                            children: [
                                                /*#__PURE__*/ _jsx(NumericFormat, {
                                                    value: v.price,
                                                    displayType: "text",
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                }),
                                                "บาท"
                                            ]
                                        })
                                    ]
                                }, "adj-fee-item-".concat(i));
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "font-light fs-14 tc-7 mt-[10px]",
                        children: [
                            "วันที่ชำระเงิน",
                            " ",
                            moment(item.pay_date, "YYYY-MM-DD").format("DD/MM/YYYY")
                        ]
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "my-4",
                        style: {
                            opacity: 0.1
                        }
                    })
                ]
            }, index);
        })
    });
}
